import { safeRandomUUID } from "newui/utils/general";
import { useRef } from "react";
import { createPortal } from "react-dom";
import { FiInfo } from "react-icons/fi"
import ReactTooltip from "react-tooltip"

interface InfoIconProps {
	size?: number;
	tooltipText: string;
}

/**
 * Displays an info icon with a tooltip
 * @param param0 
 * @returns 
 */
export const InfoTooltip: React.FC<InfoIconProps> = ({ size = 16, tooltipText }) => {
	const idRef = useRef<string>(safeRandomUUID());
	// react-tooltip renders the arrow as ::before / ::after pseudo-elements
	// whose bounding box sits between the tooltip body and the trigger. Even
	// with arrowColor="transparent" that footprint can visually overlap
	// adjacent labels. Strip both pseudo-elements entirely.
	const noArrowStyles = (
		<style>{`.info-tooltip-no-arrow::before, .info-tooltip-no-arrow::after { display: none !important; }`}</style>
	);
	// Portal to <body> so the tooltip escapes the popover/modal stacking
	// context and overlay clipping. The explicit z-index ensures it sits
	// above Chakra Modals (which use ~1400) and our portal'd popovers
	// (z-index 9999).
	const tooltipNode = (
		<ReactTooltip
			id={idRef.current}
			place="right"
			effect="solid"
			className="info-tooltip-no-arrow !border !border-gray-400 !rounded !text-xs !normal-case !px-2 !py-1 !font-normal !max-w-md !z-[10001]"
			arrowColor="transparent"
		>
			{tooltipText}
		</ReactTooltip>
	);
	return <>
		{noArrowStyles}
		<FiInfo
			className="cursor- ml-1"
			size={size}
			data-tip
			data-for={idRef.current}
		/>
		{typeof document !== "undefined"
			? createPortal(tooltipNode, document.body)
			: tooltipNode}
	</>
}